import React, { useState, useEffect } from "react";
import "./styles.scss";
import Layout from "../../components/Layout/Layout";

import { Link } from "react-router-dom";
import ViewMore from "../../components/ViewMore/ViewMore";
import CardAuction from "../../components/CardAuction/CardAuction";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchAuctions } from "../../redux/actions/auctions";



const Auction = (props) => {
  const [auctions, setAuctions] = useState([]);

  useEffect(() => {
    props.fetchAuctions();
  }, []);

  useEffect(() => {
    if (props.auctions.auctions.data) {
      setAuctions(props.auctions.auctions.data.auction);
    }
  }, [props.auctions]);

  return (
    <Layout>
      <section className="auction-section">
        <div className="bread-crumbs">
          <Link to="/">Home</Link> <i class="fa fa-caret-right pl-2 pr-2"></i>
          <Link to="/auction">Auction</Link>
          <p className="title-page">Auction</p>
        </div>
        {
          <div className="row auction-items">
            {(auctions || []).map((item, i) => {
              return (
                <Link to={`/place-bid/${item.id}`}>
                  <CardAuction
                    //like={item.like}
                    photo={item.product.images[0]}
                    item={item.product.product_name}
                    // rate={item.rate}
                    price={item.starting_price}
                    desc={item.start_time}
                    bids={item.product.numberpurchased}
                  />
                </Link>
              );
            })}
          </div>
        }

        <ViewMore />
      </section>

    </Layout>
  );
};

Auction.propTypes = {
  auctions: PropTypes.object.isRequired,
  fetchAuctions: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auctions: state.auctions,
});

const pageActions = { fetchAuctions };
export default connect(mapStateToProps, pageActions)(Auction);
